import React from "react";
import styles from "../StatutoryDetails/StatutoryDetails.module.css";
import Mail from "../../commomComponents/mail";
import ReactHtmlParser from "react-html-parser";
import getStatuaryDetails from "../../services/request/statutory";
import { IMAGE_URL, SITE_ID } from "../../services/apiConstants";
import BannerWithHeading from "../../commomComponents/bannerWithHeading";
import Loader from "../../commomComponents/Loader";
import SeoHelmet from "../../commomComponents/seoHelmet";

const axios = require("axios");

class StatutoryDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      content: [],
      banner: [],
      isLoading: true,
    };
    this.myRef = React.createRef();
    this.myRef2 = React.createRef();
  }
  componentWillMount = () => {
    document.title =
      " Statutory Details - Compliance & Regulations | ICICI Pru Alternates";
    this.callAllApis();
  };

  callAllApis = () => {
    this.setState({ isLoading: true });
    const statutory = getStatuaryDetails();
    statutory.then((data) => {
      this.setState({
        isLoading: false,
        content: data.data.content,
        banner: data.data.banner,
      });
    });
  };

  render() {
    const { content, banner, isLoading } = this.state;
    return (
      <div>
        {isLoading ? (
          <Loader />
        ) : (
          <>
            <SeoHelmet
              title=" Statutory Details - Compliance & Regulations | ICICI Pru Alternates"
              description="Discover the statutory details and compliance regulations for ICICI Pru Alternates. Learn about our adherence to financial regulations and legal standards."
              url="https://www.iciciprualternates.com/statutory-details"
            />

            {banner.length > 0 && banner[0].image ? (
              <BannerWithHeading
                bannerImage={IMAGE_URL + banner[0].image + SITE_ID}
                heading={banner[0].title}
              />
            ) : null}
            <div className={styles.container} ref={this.myRef}>
              {content.map((data) => {
                return (
                  <div>
                    <h1 className={styles.mainTitle}>{data.title}</h1>
                    <p className={styles.body}>
                      {ReactHtmlParser(data.description)}
                    </p>
                  </div>
                );
              })}
            </div>
            <Mail />
          </>
        )}
      </div>
    );
  }
}
export default StatutoryDetails;
